import { render, staticRenderFns } from "./TemplateDetailsDrawer.vue?vue&type=template&id=9f2b179e&scoped=true"
import script from "./TemplateDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./TemplateDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetailsDrawer.vue?vue&type=style&index=0&id=9f2b179e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2b179e",
  null
  
)

export default component.exports